/**
 * AR06 copy (one group per control; a ticket edits only its own file). Covers ordinary invoice
 * collections and debit-note settlement (ALC-4541, extended ALC-4542). Aggregate children are
 * disclosed once per invoice as an untraced coverage limit: the deposit records an outbound partner
 * payout, with no link to incoming cash, so AR06 does not check that settlement path yet. Discounts
 * ride on the same receipt journal already checked above and raise no reason of their own.
 */
export const ar06PtBr = {
  title: 'Recebimentos e baixas',
  description:
    'Recebimentos de faturas e notas de débito conciliados com os títulos e a contabilidade.',
  prerequisite: '',
  reasons: {
    UNALLOCATED_CASH: 'Caixa não alocado',
    PARTIAL_ALLOCATION: 'Baixa parcial do título',
    BANK_MATCHED_NO_JOURNAL: 'Conciliado no banco sem lançamento contábil',
    MISSING_JOURNAL: 'Sem lançamento contábil',
    REVERSED_JOURNAL: 'Lançamento contábil revertido',
    EXTERNAL_PAID_UNCONFIRMED: 'Pagamento externo sem confirmação bancária',
    DEBIT_NOTE_PARTIAL_ALLOCATION: 'Baixa parcial da nota de débito',
    AGGREGATE_SETTLEMENT_UNTRACED: 'Liquidação agregada sem vínculo com o recebimento',
  },
  withheldAmountPrefix: 'Retido na fonte',
  withheldAmountExpectedNote: 'esperado na nota',
  breakdownTruncated:
    'Mostrando apenas as 100 primeiras pendências; a distribuição por motivo não é exibida.',
};

export const ar06En: typeof ar06PtBr = {
  title: 'Receipts and settlements',
  description: 'Invoice and debit-note receipts reconciled with titles and the GL.',
  prerequisite: '',
  reasons: {
    UNALLOCATED_CASH: 'Unallocated cash',
    PARTIAL_ALLOCATION: 'Title partially settled',
    BANK_MATCHED_NO_JOURNAL: 'Bank-matched with no GL journal',
    MISSING_JOURNAL: 'No GL journal',
    REVERSED_JOURNAL: 'GL journal reversed',
    EXTERNAL_PAID_UNCONFIRMED: 'External payment without bank confirmation',
    DEBIT_NOTE_PARTIAL_ALLOCATION: 'Debit note partially settled',
    AGGREGATE_SETTLEMENT_UNTRACED: 'Aggregate settlement not linked to incoming cash',
  },
  withheldAmountPrefix: 'Withheld at source',
  withheldAmountExpectedNote: 'expected on invoice',
  breakdownTruncated: 'Showing only the first 100 findings; the breakdown by reason is hidden.',
};
